(function () {
	angular
		.module('trackeye')
		.factory('MigrationService', MigrationService);

	MigrationService.$inject = ["C4ApiService"];

	function MigrationService(api) {
		var exports = {};

		exports.check = function (ident, password) {
			return api.migrationCheck(ident, password);
		};

		return exports;
	}
})();